export default "__VITE_ASSET__BEZ_dPJt__"